export const FEES_TEXT = Object.freeze({
  page: {
    title: 'Comisiones',
    subtitle: 'Gestión y seguimiento de comisiones.',
    actions: {
      newFee: 'Nueva comisión',
    },
    confirm: {
      noProvider: 'Sin proveedor',
      noConcept: 'Sin concepto',
      delete: {
        title: 'Eliminar comisión',
        subtitle: 'Esta acción no se puede deshacer.',
        messageDefault: 'Confirma que deseas eliminar esta comisión.',
        confirm: 'Eliminar',
        confirming: 'Eliminando...',
      },
      approve: {
        titleApprove: 'Aprobar comisión',
        titleUnapprove: 'No aprobar comisión',
        subtitleApprove: 'Confirma para marcar esta comisión como aprobada.',
        subtitleUnapprove: 'Confirma para quitar la aprobación de esta comisión.',
        messageApproveDefault: 'Confirma que deseas aprobar esta comisión.',
        messageUnapproveDefault: 'Confirma que deseas no aprobar esta comisión.',
        confirmApprove: 'Aprobar',
        confirmUnapprove: 'No aprobar',
        confirmingApprove: 'Aprobando...',
        confirmingUpdate: 'Actualizando...',
      },
      cancel: 'Cancelar',
      summary: ({ provider, concept, amount }) => `Proveedor: ${provider}\nConcepto: ${concept}\nMonto: ${amount}`,
    },
  },
  metrics: {
    latestMetaPrefix: 'Fecha de registro:',
    kpis: {
      total: 'Total comisiones',
      pendingToPay: 'Pendiente a pagar',
      paid: 'Pagado',
      latest: 'Última comisión registrada',
    },
  },
  list: {
    status: {
      paid: 'Pagado',
      pending: 'Pendiente',
    },
    hasXml: {
      yes: 'Sí',
      no: 'No',
    },
  },
  toolbar: {
    searchPlaceholder: 'Buscar por colaborador, proveedor o concepto',
    filtersButtonTitle: 'Filtros',
    searchButtonTitle: 'Buscar',
    emptyOption: 'Sin opción disponible',
    dateRangePresets: [
      { key: 'this_month', label: 'Este mes' },
      { key: 'last_month', label: 'Mes anterior' },
      { key: 'this_year', label: 'Año actual' },
      { key: 'last_year', label: 'Año anterior' },
    ],
    allOptionLabels: {
      provider: 'Todos',
    },
    selectionAllLabels: {
      provider: 'Todos',
      collaborator: 'Colaborador: Todos',
    },
    filters: {
      collaborator: { label: 'Colaborador', placeholder: 'Selecciona colaborador', searchable: true },
      provider: { label: 'Proveedor', placeholder: 'Selecciona proveedor', searchable: true },
      expenseClass: { label: 'Clase', placeholder: 'Selecciona clase', searchable: true },
      category: { label: 'Categoría', placeholder: 'Selecciona categoría', searchable: true },
      customer: { label: 'Cliente', placeholder: 'Selecciona cliente', searchable: true },
      tags: { label: 'Etiquetas', placeholder: 'Selecciona etiquetas', searchable: true },
      hasXml: { label: 'Tiene XML', placeholder: 'Selecciona opción', searchable: false },
      currency: { label: 'Moneda', placeholder: 'Selecciona moneda', searchable: true },
      area: { label: 'Área', placeholder: 'Selecciona área', searchable: true },
    },
  },
  table: {
    loading: 'Cargando comisiones...',
    empty: 'Sin comisiones disponibles para los filtros seleccionados.',
    sortTitles: {
      date: 'Ordenar por fecha',
      provider: 'Ordenar por proveedor',
      subtotal: 'Ordenar por subtotal',
      total: 'Ordenar por total',
      paymentDate: 'Ordenar por fecha de pago',
    },
    columns: {
      date: 'FECHA',
      provider: 'PROVEEDOR',
      category: 'CATEGORÍA',
      concept: 'CONCEPTO',
      business: 'NEGOCIO',
      subtotal: 'SUBTOTAL',
      taxes: 'IMPUESTOS',
      total: 'TOTAL',
      paymentDate: 'FECHA PAGO',
      status: 'ESTADO',
      reference: 'REFERENCIA',
    },
    links: {
      providerDetail: 'Ir al detalle del proveedor',
      customerDetail: 'Ir al detalle del cliente',
      saleDetail: 'Ir al detalle del negocio',
    },
    actions: {
      edit: 'Editar',
      unapprove: 'No aprobar',
      delete: 'Eliminar',
      more: 'Más acciones',
      downloadXml: 'Descargar xml',
      downloadPdf: 'Descargar pdf',
      downloadReceipt: 'Descargar comprobante',
    },
  },
  flow: {
    errors: {
      save: 'No fue posible guardar la comisión.',
      detail: 'No fue posible cargar el detalle de la comisión.',
      payIdentify: 'No fue posible identificar la comisión a pagar.',
      paySave: 'No fue posible registrar el pago de la comisión.',
      delete: 'No fue posible eliminar la comisión.',
      approve: 'No fue posible actualizar la aprobación de la comisión.',
    },
    success: {
      create: 'Comisión guardada correctamente.',
      update: 'Comisión actualizada correctamente.',
      pay: 'Pago de comisión registrado correctamente.',
      delete: 'Comisión eliminada correctamente.',
      approve: 'Comisión aprobada correctamente.',
      unapprove: 'Comisión actualizada a no aprobada.',
    },
    pending: {
      referencePrefix: 'Comisión',
      suffix: 'estará disponible pronto.',
      actions: {
        pay: 'Pagar',
        approve: 'Aprobar',
        delete: 'Eliminar',
        downloadXml: 'Descarga XML de',
        downloadPdf: 'Descarga PDF de',
        downloadReceipt: 'Descarga comprobante de',
      },
    },
  },
  modal: {
    closeAriaLabel: 'Cerrar modal',
    sectionsAriaLabel: 'Secciones del formulario de comisión',
    titleCreate: 'Nueva comisión',
    titleEdit: 'Editar comisión',
    subtitleCreate: 'Captura rápida para registrar una comisión.',
    subtitleEdit: 'Actualiza la información de la comisión seleccionada.',
    cancel: 'Cancelar',
    submitCreate: 'Guardar',
    submitEdit: 'Actualizar',
    submitting: 'Guardando...',
    sections: {
      general: {
        title: 'Información general',
        description: 'Comprobante, tipo de comisión, impuestos y montos.',
      },
      operational: {
        title: 'Gestión operativa',
        description: 'Folio, fechas, cliente y negocio asociado.',
      },
      details: {
        title: 'Detalles',
        description: 'Etiquetas, área y comentarios internos.',
      },
      files: {
        title: 'Archivos',
        description: 'Adjuntos de la comisión y evidencia documental.',
      },
    },
    validation: {
      supplierRequired: 'Selecciona un proveedor.',
      collaboratorRequired: 'Selecciona un colaborador.',
      conceptRequired: 'Captura el concepto de la comisión.',
      amountInvalid: 'El monto debe ser mayor a 0.',
      recurringCountInvalid: 'La cantidad de comisiones debe ser mayor a 0.',
      firstInstallmentRequired: 'Selecciona la primera mensualidad.',
      periodicityRequired: 'Selecciona la periodicidad de la comisión.',
    },
    warnings: {
      discountReset: 'No se puede capturar un descuento mayor al monto. Se restableció a 0.',
      deductionsReset: 'No se puede capturar deducciones mayores al monto. Se restableció a 0.',
    },
    supplierInline: {
      requiresClassCategory: 'Selecciona clase y categoría para crear el proveedor.',
      createError: 'No fue posible crear el proveedor.',
    },
    selectOptions: {
      commissionTypes: {
        collaborator: 'Colaborador',
        supplier: 'Proveedor',
      },
      documentTypes: {
        cfdi: 'CFDI',
        simpleNote: 'Nota simple',
      },
    },
    defaultConcept: 'Pago de Comisión',
    fallbackSaleLabel: ({ id }) => `Negocio #${id}`,
  },
  sections: {
    common: {
      noOption: 'Sin opción disponible',
      today: 'Hoy',
    },
    sharedOperational: {
      title: 'Gestión Operativa',
      subtitle: 'Folio, fechas y relación con cliente o negocio.',
      folio: 'Folio',
      cfdiDate: 'Fecha CFDI',
      customer: 'Cliente',
      sale: 'Negocio',
      placeholders: {
        folio: 'Folio',
        date: 'Selecciona fecha',
        customer: 'Selecciona cliente',
        sale: 'Selecciona negocio',
      },
    },
    sharedDetails: {
      title: 'Detalles',
      subtitle: 'Organiza la comisión con etiquetas, área y notas internas.',
      entityLabel: 'comisión',
      tags: 'Etiquetas',
      area: 'Área',
      comments: 'Comentarios',
      placeholders: {
        tags: 'Selecciona etiquetas',
        area: 'Selecciona área',
        comments: 'Comentarios de la comisión',
      },
    },
    sharedFiles: {
      title: 'Archivos',
      subtitle: 'Adjunta documentos de la comisión para referencia y validación.',
      entityLabel: 'comisión',
      invoiceFiles: 'Factura (PDF y XML)',
      voucher: 'Comprobante',
      purchaseOrder: 'Orden de compra',
      additionalFile: 'Archivo adicional',
      additionalModeFile: 'Archivo',
      additionalModeUrl: 'URL',
      selectFile: 'Seleccionar archivo',
      noFile: 'Ningún archivo seleccionado',
      placeholders: {
        additionalUrl: 'https://...',
      },
    },
    general: {
      title: 'Información general',
      subtitle: 'Configuración del comprobante, comisionista, impuestos y montos.',
      statusPrefix: 'Estado:',
      statusHelper: 'Este campo se actualiza automáticamente según el flujo de la comisión.',
      voucherType: 'Tipo de comprobante',
      commissionType: 'Tipo de comisión',
      supplier: 'Proveedor',
      collaborator: 'Colaborador',
      supplierName: 'Nombre del proveedor',
      supplierContributor: 'Dato de facturación del proveedor',
      amountsTitle: 'Importes de la comisión',
      amountsSubtitle: 'Montos base, descuentos y resumen de impuestos.',
      frequencyTitle: 'Frecuencia de la comisión',
      expensesCount: 'Cantidad de comisiones',
      firstInstallment: 'Primer mensualidad',
      periodicity: 'Periodicidad de la comisión',
      total: 'Total',
      discount: 'Descuento',
      deductions: 'Deducciones',
      buttons: {
        hide: 'Ocultar',
        newSupplier: '+ Nuevo proveedor',
        cancel: 'Cancelar',
        saveAndUseSupplier: 'Guardar y usar proveedor',
      },
      placeholders: {
        supplier: 'Selecciona proveedor',
        collaborator: 'Selecciona colaborador',
        supplierName: 'Nombre del proveedor',
        supplierContributor: 'Selecciona dato de facturación',
        firstInstallment: 'Selecciona mes',
        periodicity: 'Selecciona periodicidad',
        expensesCount: '1',
      },
      frequencyOptions: {
        unique: 'Único',
        monthly: 'Mensual',
        multiple: 'Múltiple',
      },
      defaultPendingStatus: 'Pendiente',
    },
    taxes: {
      title: 'Impuestos',
      subtitle: 'Selecciona el tipo de impuestos aplicables para esta comisión.',
      withoutTaxes: 'Sin impuestos',
      taxType: 'Tipo de impuestos',
      taxes: 'Impuestos',
      placeholders: {
        taxes: 'Selecciona impuestos',
        group: 'Selecciona grupo',
      },
      fallbackTaxLabel: ({ id }) => `Impuesto #${id}`,
      fallbackGroupLabel: 'Grupo',
      fallbackIndividualLabel: 'Individual',
    },
    totals: {
      subtotal: 'Subtotal',
      transferred: 'Trasladados',
      withheld: 'Retenciones',
      total: 'Total',
    },
    schedule: {
      expenseDate: 'Fecha de comisión',
      paymentDate: 'Fecha de pago',
      concept: 'Concepto',
      placeholders: {
        date: 'Selecciona fecha',
        concept: 'Concepto de la comisión',
      },
    },
  },
});
